const CART_DEFAULT = {
  metal: 0,
  gold: 0,
  wood: 0,
};

const ITEMS = [
  {
    id: 'metal',
    name: 'Steel',
    price: 19.99,
    features: [
      {
        icon: 'mdi-shield-lock',
        text: 'Premium Metal Build',
        caption: 'Protects secrets better than plastic',
      },
      {
        icon: 'mdi-database-lock',
        text: 'Stores Up to 10 Secrets',
        caption: 'Keep multiple secrets safe in one card.',
      },
      {
        icon: 'mdi-water-off',
        text: 'Scratch & Water Resistant',
        caption: 'Built to last, no matter what.',
      },
    ],
  },
  {
    id: 'gold',
    name: 'Aurum',
    price: 24.99,
    features: [
      {
        icon: 'mdi-gold',
        text: 'Gold-Plated Finish',
        caption: 'Same security, premium style.',
      },
      {
        icon: 'mdi-database-lock',
        text: 'Stores Up to 10 Secrets',
        caption: 'Secure multiple secrets effortlessly. ',
      },
      {
        icon: 'mdi-crown',
        text: 'Elite Edition',
        caption: 'A luxury card for true collectors.',
      },
    ],
  },
  {
    id: 'wood',
    name: 'Terra',
    price: 24.99,
    capacity: '5-7 passwords',
    features: [
      {
        icon: 'mdi-leaf',
        text: 'Eco-Friendly Material',
        caption: 'Made from sustainable wood.',
      },
      {
        icon: 'mdi-feather',
        text: 'Lightweight Design',
        caption: 'Carry security without the weight.',
      },
      {
        icon: 'mdi-texture',
        text: 'Natural & Unique Look',
        caption: 'Each card has its own pattern.',
      },
    ],
  },
];

const PERSONALIZATION_PRICE = 3.99;

const PERSONALIZATIONS_DEFAULT = {
  metal: [],
  gold: [],
  wood: [],
};

export { CART_DEFAULT, PERSONALIZATIONS_DEFAULT, ITEMS, PERSONALIZATION_PRICE };
